import type { JSX } from 'react';
import { memo, useMemo } from 'react';

import ActivityLog from '@/components/ActivityLog';
import hiddenTimelineEvents from '@/constants/hiddenTimelineEvents';
import TimelineItemWrapper from '@/pages/Timeline/components/TimelineItemWrapper';
import type { ActivityLogWithParsedData } from '@/pages/Timeline/types';
import type { ActivityLog as ActivityLogInterface } from '@/types/activityLog';
import parseActivityLogData from '@/utils/parseActivityLogData';

interface Props {
  activityLog: ActivityLogInterface;
}

const TimelineItem = ({ activityLog }: Props): JSX.Element | null => {
  const { action: event } = activityLog;

  const activityLogWithParsedData: ActivityLogWithParsedData = useMemo(() => {
    return {
      ...activityLog,
      data: parseActivityLogData(activityLog.data)
    };
  }, [activityLog]);

  if (!event || (event && hiddenTimelineEvents.includes(event))) {
    return null;
  }

  return (
    <TimelineItemWrapper activityLog={activityLogWithParsedData}>
      <ActivityLog activityLog={activityLog} />
    </TimelineItemWrapper>
  );
};

export default memo(TimelineItem);
